<div class="text-xl font-semibold">
  <ng-content />
</div>
